import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

export default class IconButton extends React.PureComponent {
  render() {
    const imgStyle = {
      width: this.props.imageWidth,
    };

    const classnames = this.props.classnames ? `${this.props.classnames} self-serve-icon-button` : 'self-serve-icon-button';
    const includeTooltip = !(this.props.tooltipText === '' && this.props.tooltipPlacement === '');

    const { tooltipText } = this.props;
    return (
      <div className={this.props.containerClass} >
        <button
          className={classnames}
          onClick={this.props.onClick}
          data-class="icon-button-tooltip"
          data-delay-hide="50"
          data-tip={includeTooltip ? 'tooltip' : null}
        >
          <div className="self-serve-icon-button-img-container" style={imgStyle}>
            { this.props.imageSrc &&
              <img alt={this.props.imageAlt} src={this.props.imageSrc} />
            }
            { this.props.icon &&
              this.props.icon
            }
          </div>
          <span>{this.props.text}</span>
        </button>
        { includeTooltip &&
          <ReactTooltip
            className="icon-button-tooltip"
            place={this.props.tooltipPlacement}
            type="light"
            effect="solid"
            getContent={[
              () => (
                <div>
                  {tooltipText}
                </div>
              ),
            ]}
          />
        }
      </div>
    );
  }
}

IconButton.defaultProps = {
  classnames: '',
  containerClass: '',
  icon: null,
  imageAlt: '',
  imageSrc: '',
  imageWidth: 15,
  onClick: null,
  tooltipText: '',
  tooltipPlacement: '',
};

IconButton.propTypes = {
  classnames: PropTypes.string,
  containerClass: PropTypes.string,
  icon: PropTypes.element,
  imageAlt: PropTypes.string,
  imageSrc: PropTypes.string,
  imageWidth: PropTypes.number,
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired,
  tooltipText: PropTypes.string,
  tooltipPlacement: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilder/IconButton.jsx